import { CfCardFullImageProps } from "components/Cards/CardFullImage/CfCardFullImage/schema";
import {
  convertCfImageProps,
  convertSingleImage,
} from "components/Image/CfImage";
import CardFullImage, {
  CardFullImageProps,
} from "components/Cards/CardFullImage";
import CfAnchor from "components/Anchor";
import Image from "components/Image";
import Markdown from "react-markdown";
import React from "react";

const converCfCardFullImageProps = ({
  cardImage,
  title,
  description,
  cardAnchor,
  ctaLabel,
  centered,
  promo,
}: CfCardFullImageProps): CardFullImageProps => {
  const singleImage = convertSingleImage({
    image: cardImage,
  });
  const image = singleImage && <Image {...convertCfImageProps(singleImage)} />;

  return {
    title,
    description: <Markdown>{description?.description}</Markdown>,
    ctaLabel,
    centered: !!centered,
    isPromo: !!promo,
    image,
    customClass: cardAnchor ? "elevation-card cursor-pointer" : "",
  };
};

const CfCardFullImage = (props: CfCardFullImageProps) => (
  <CfAnchor {...props.cardAnchor}>
    <CardFullImage {...converCfCardFullImageProps(props)} />
  </CfAnchor>
);

export default CfCardFullImage;
